// extracted by mini-css-extract-plugin
export default {"comment":"index_comment_V00YL","commentTitle":"index_commentTitle_hHBYe","commentBox":"index_commentBox_veIhy"};